import { 
  DISTANCE_LABELS_SOURCE,
  DISTANCE_LABELS_LAYER
} from './constants';
import { 
  calculateMidpoint, 
  formatDistance, 
  manhattanDistance,
  safeSetSourceData
} from './utils';



// Generate distance label data
export const generateDistanceLabels = (path, pathType, locations) => {
  if (!path || path.length < 2) return [];
  
  const distanceFeatures = [];
  
  for (let i = 0; i < path.length - 1; i++) {
    const currentId = path[i];
    const nextId = path[i + 1];
    
    const currentLocation = locations.find(loc => loc.id === currentId);
    const nextLocation = locations.find(loc => loc.id === nextId);
    
    if (!currentLocation || !nextLocation) continue;
    
    // Validate coordinates
    if (typeof currentLocation.latitude !== 'number' || 
        typeof currentLocation.longitude !== 'number' ||
        typeof nextLocation.latitude !== 'number' || 
        typeof nextLocation.longitude !== 'number' ||
        isNaN(currentLocation.latitude) || isNaN(currentLocation.longitude) ||
        isNaN(nextLocation.latitude) || isNaN(nextLocation.longitude)) {
      continue;
    }
    
    // Calculate distance between two points
    const distance = manhattanDistance(
      currentLocation.latitude,
      currentLocation.longitude,
      nextLocation.latitude,
      nextLocation.longitude
    );
    
    // Calculate midpoint between two points for label position
    const midpoint = calculateMidpoint(
      [currentLocation.longitude, currentLocation.latitude],
      [nextLocation.longitude, nextLocation.latitude]
    );
    
    // Create label feature
    distanceFeatures.push({
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: midpoint
      },
      properties: {
        distance: formatDistance(distance),
        pathType: pathType
      }
    });
  }
  
  return distanceFeatures;
};

// Update distance labels
export const updateDistanceLabels = ({
  map,
  mapReady,
  sourcesReady,
  shouldShowDistanceLabels,
  shouldShowAutoPath,
  shouldShowCustomPath,
  autoPath,
  customPath,
  locations
}) => {
  // Early exit conditions
  if (!shouldShowDistanceLabels || !mapReady || !sourcesReady || !map) {
    return;
  }

  try {
    // Check if distance labels layer exists
    const layerExists = map.getLayer(DISTANCE_LABELS_LAYER);
    if (!layerExists) {
      console.error(`TSP Distance labels layer not found: ${DISTANCE_LABELS_LAYER}`);
      return;
    }

    // Check if distance labels source exists
    const sourceExists = map.getSource(DISTANCE_LABELS_SOURCE);
    if (!sourceExists) {
      console.error(`TSP Distance labels source not found: ${DISTANCE_LABELS_SOURCE}`);
      return;
    }

    // Generate distance label features for auto path
    let autoDistanceFeatures = [];
    if (shouldShowAutoPath && autoPath && autoPath.length > 1) {
      autoDistanceFeatures = generateDistanceLabels(autoPath, 'auto', locations);
    }
    
    // Generate distance label features for custom path
    let customDistanceFeatures = [];
    if (shouldShowCustomPath && customPath && customPath.length > 1) {
      customDistanceFeatures = generateDistanceLabels(customPath, 'custom', locations);
    }
    
    // Combine all distance labels
    const allDistanceFeatures = [...autoDistanceFeatures, ...customDistanceFeatures];
    
    // Create GeoJSON data structure
    const data = {
      type: 'FeatureCollection',
      features: allDistanceFeatures
    };
    
    // Update distance label data source
    const success = safeSetSourceData(map, mapReady, sourcesReady, DISTANCE_LABELS_SOURCE, data);
    
    if (!success) {
      console.error('TSP: Failed to update distance labels source');
    }
    
  } catch (err) {
    console.error("TSP Error updating distance labels:", err);
  }
};

// Set distance label layer visibility
export const setDistanceLabelsVisibility = (map, mapReady, shouldShowDistanceLabels) => {
  if (!map || !mapReady) return;
  
  try {
    map.setLayoutProperty(
      DISTANCE_LABELS_LAYER,
      'visibility',
      shouldShowDistanceLabels ? 'visible' : 'none'
    );
  } catch (err) {
    console.error("TSP Error setting distance label visibility:", err);
  }
};

 